import { render, staticRenderFns } from "./MyAccountPage.vue?vue&type=template&id=4e9f8ede&"
import script from "./MyAccountPage.vue?vue&type=script&lang=js&"
export * from "./MyAccountPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports